import {
  initCoreFrontApp,
  initCoreFrontAppArgs,
} from '../CORE/src/front/AppInitializer/initCoreFrontApp'
import models from '../models/fireModels'
// @ts-ignore
import AgreementFlow from './AgreementFlow/AgreementFlow.vue'
// @ts-ignore
import AgreementFlowWithAgreementRequestId from './AgreementFlow/AgreementFlowWithAgreementRequestId.vue'
// @ts-ignore
// import FlowDisplayWithTemplateId from './FlowPages/FlowDisplayWithTemplateId.vue'
import AgreementTemplateSelectList from './AgreementTemplateSelect/AgreementTemplateSelectList.vue'
import './components/submitAreaForPsAgreements'
// @ts-ignore
import PsAgreementEmbeddableTemplateExplanation from '../services/PsAgreementEmbeddableTemplateParser/PsAgreementEmbeddableTemplateExplanation.vue'
import AgreementFlowWithAgreementTemplateData from './AgreementFlow/AgreementFlowWithAgreementTemplateData.vue'
import {
  openAgreementFlowPreviewModalWithPsAgreementRequest,
  openAgreementFlowPreviewModalWithPsAgreementTemplate,
} from './AgreementFlowDefinitionInput/AgreementFlowDefinitionInputService'
import SignaturePadInputWithButton from './services/SignaturePadService/SignaturePadInputWithButton.vue'
import DataListCreatedByMeFilter from './components/DataListCreatedByMeFilter.vue'
import PsNewsDetailModal from './components/PsNewsDetailModal.vue'
const coreFrontInitArg: initCoreFrontAppArgs = {
  modelDefinitions: models,
  additionalRoutes: [
    // {
    //   path: '/FlowDisplayWithTemplateId',
    //   component: FlowDisplayWithTemplateId
    // },
    {
      path: '/AgreementFlowWithAgreementRequestId/:AgreementFlowWithAgreementRequestId',
      props: true,
      // @ts-ignore
      component: () => import('./AgreementFlow/AgreementFlowWithAgreementRequestId.vue'),
    },
    {
      path: '/agreement/:AgreementFlowWithAgreementRequestId',
      name: 'agreement',
      props: true,
      component: () => import('./AgreementFlow/AgreementFlowWithAgreementRequestId.vue'),
      meta: { layout: 'empty' },
    },
  ],
}

/**
 * Initialize core
 */
initCoreFrontApp(coreFrontInitArg).then(startAppFunction => {
  if (!$core.$ps) {
    $core.$ps = {}
  }
  $core.$ps.openAgreementFlowPreviewModalWithPsAgreementRequest = openAgreementFlowPreviewModalWithPsAgreementRequest
  $core.$ps.openAgreementFlowPreviewModalWithPsAgreementTemplate = openAgreementFlowPreviewModalWithPsAgreementTemplate
  $core.VueClass.component('SignaturePadInputWithButton', SignaturePadInputWithButton)
  $core.VueClass.component('DataListCreatedByMeFilter', DataListCreatedByMeFilter)
  $core.VueClass.component('PsNewsDetailModal', PsNewsDetailModal)
  // @ts-ignore
  $core.VueClass.component(
    'AgreementFlowDefinitionInput',
    $core.$frameworkUtils.defineAsyncComponent(() =>
      import('./AgreementFlowDefinitionInput/AgreementFlowDefinitionInput.vue'),
    ),
  )
  $core.VueClass.component('AgreementFlow', AgreementFlow)
  $core.VueClass.component(
    'AgreementFlowWithAgreementRequestId',
    AgreementFlowWithAgreementRequestId,
  )
  $core.VueClass.component(
    'AgreementFlowWithAgreementTemplateData',
    AgreementFlowWithAgreementTemplateData,
  )
  $core.VueClass.component(
    'PsAgreementEmbeddableTemplateExplanation',
    PsAgreementEmbeddableTemplateExplanation,
  )
  $core.VueClass.component('PsAgreementEmbeddableTemplateExplanationOpenLink', {
    template: `<a href="#" @click.prevent.stop="() => $core.openAgreementTemplateQuickCreateNewAgreementFormServiceModal()">>> 埋め込み文字の利用方法</a>`,
  })
  $core.VueClass.component('PsAgreementEmbeddableTemplateHelpDoc', {
    template: `<HelpDoc>埋め込み文字 (例: <code v-pre>{{ 飼い主様_お名前 }}</code>) を利用して、医院情報, 飼い主様情報 を表現することが可能です。 <PsAgreementEmbeddableTemplateExplanationOpenLink/> </HelpDoc>`,
  })
  $core.openAgreementTemplateQuickCreateNewAgreementFormServiceModal = () => {
    $core.$modals.openModal({
      component: 'PsAgreementEmbeddableTemplateExplanation',
      modalProps: {
        title: '埋め込み文字の利用方法',
      },
    })
  }
  $core.VueClass.component('AgreementTemplateSelectList', AgreementTemplateSelectList)
  $core.$appHook.on(
    'CORE.frontApp.beforeInit',
    async args => {
      await new Promise(resolve => setTimeout(resolve, 1000))
      // 医院向け App である場合には 強制的に 医院を選ばせる
      if ($core.$appDefinitionLoader.appKey !== 'ft-clinic-app') {
        return
      }
      // @ts-ignore
      if ($core.$embAuth.user.ps_clinic) {
        return
      }
      const openModalAndSelectClinic = async () => {
        const lsCacheKey = 'last_selected_admin_ps_clinic_id'
        await new Promise(resolve => {
          const modalId = $core.$modals.openModal({
            modalProps: {
              title: '医院を選択してください',
              hideFooter: true,
              hideHeaderClose: true,
              noCloseOnBackdrop: true,
              size: 'sm',
            },
            component: {
              template: `<div class="d-flex flex-column gap-2">
<p class="mb-0">管理者モードでログインしているため 医院を選択する必要があります。</p>
<multiselect v-if="initialized" v-model="selectedClinicId" :options="clinicOptionIds" :customLabel="customLabelFunc" />
<span class="btn btn-primary" @click="onSubmit">選択</span>
</div>`,
              data() {
                return {
                  selectedClinicId: $core.$lsCache.get(lsCacheKey),
                  clinicOptions: [],
                  clinicsById: {},
                  initialized: false,
                }
              },
              async mounted() {
                const clinicOptions = await $core.$models.ps_clinics.find({
                  limit: -1,
                })
                this.clinicsById = clinicOptions.reduce((acc, clinic) => {
                  acc[clinic.id] = clinic
                  return acc
                }, {})
                this.clinicOptions = clinicOptions
                this.initialized = true
              },
              computed: {
                clinicOptionIds() {
                  return Object.keys(this.clinicsById)
                },
                customLabelFunc() {
                  return (clinicId: string) => this.clinicsById?.[clinicId]?.name
                },
              },
              methods: {
                onSubmit() {
                  if (
                    !this.selectedClinicId ||
                    !this.clinicsById[this.selectedClinicId]
                  ) {
                    return
                  }
                  // @ts-ignore
                  $core.$embAuth.user.ps_clinic = this.clinicsById[this.selectedClinicId]
                  $core.$modals.closeModal(modalId as string)
                  $core.$lsCache.set(lsCacheKey, this.selectedClinicId)
                  resolve(true)
                },
              },
            },
          })
        })
      }
      await openModalAndSelectClinic()
    },
    'load-ps-clinic-if-admin',
    99999,
  )
  // ログイン画面にロゴを表示
  const PS_LOGO_URL = 'https://lp.pet-sign.com/assets/images/common/logo1@3x.png'
  const PS_LOGO_ID = 'ps-login-logo'
  const insertLoginLogo = () => {
    if (document.getElementById(PS_LOGO_ID)) return
    const cardContainer = document.querySelector('.app-hookable-component .col-12.col-sm-10.col-md-5')
    if (!cardContainer) return
    const logoDiv = document.createElement('div')
    logoDiv.id = PS_LOGO_ID
    logoDiv.style.textAlign = 'center'
    logoDiv.style.marginBottom = '24px'
    const img = document.createElement('img')
    img.src = PS_LOGO_URL
    img.alt = 'PetSign'
    img.style.maxWidth = '200px'
    img.style.height = 'auto'
    logoDiv.appendChild(img)
    cardContainer.insertBefore(logoDiv, cardContainer.firstChild)
  }
  $core.$router.afterEach((to) => {
    if (to.name === 'signIn') {
      setTimeout(insertLoginLogo, 100)
    }
  })
  // 初回直接アクセス時
  if ($core.$router.currentRoute.value?.name === 'signIn') {
    setTimeout(insertLoginLogo, 300)
  }

  startAppFunction() // start app
})
